import React, { useEffect } from 'react';
import { Check, X as CloseIcon } from 'lucide-react';
import './Popup.css';

const SuccessPopup = ({ isOpen, onClose, title, message, timer }) => {
  useEffect(() => {
    if (isOpen && timer) {
      const timeoutId = setTimeout(() => {
        onClose();
      }, timer);

      return () => clearTimeout(timeoutId);
    }
  }, [isOpen, timer, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`popup-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="popup-close-btn">
          <CloseIcon size={24} />
        </button>
        <div className="popup-icon-wrapper success">
          <Check size={48} strokeWidth={3} />
        </div>
        <h2 className="popup-title">{title}</h2>
        <p className="popup-message">{message}</p>
        <div className="popup-actions">
          <button onClick={onClose} className="popup-button success">
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;